<div>
    <div [formGroup]="signature_info">
        <label>Signatory* </label>
        <input formControlName="signatory" type="text" placeholder="Signatory">
        <br>
        <label>Party to the Bill of Lading* </label>
        <select formControlName="party">
            <option value="Customer">Customer</option>
            <option value="Consignee">Consignee</option>
            <option value="Carrier">Carrier</option>
            <option value="Shipper">Shipper</option>
        </select>
    </div>
    <canvas #signPadCanvas style="border: 1px solid black;background-color: white"></canvas>
    <br>
    <button (click)="clear()">Clear</button>
</div>